import { Star } from "lucide-react";
import { FadeUp, SectionHeading } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";
import { GOOGLE_REVIEWS, GOOGLE_REVIEWS_URL } from "../data/site";

const GoogleG = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"
    />
    <path
      fill="#FBBC05"
      d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"
    />
    <path
      fill="#EA4335"
      d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
    />
  </svg>
);

export default function Testimonials() {
  const { T, lang } = useLang();
  const R = T.testimonials;
  const locale = { es: "es-AR", pt: "pt-BR", en: "en" }[lang];
  const fmt = (iso) =>
    new Date(`${iso}T12:00:00`).toLocaleDateString(locale, { year: "numeric", month: "short" });

  return (
    <section id="resenas" data-testid="testimonials-section" className="bg-federasol-blush/60 py-14 md:py-24">
      <div className="container-x">
        <SectionHeading eyebrow={R.eyebrow} title={R.title} subtitle={R.subtitle} />

        <div className="mt-12 grid gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4">
          {GOOGLE_REVIEWS.map((rev, i) => (
            <FadeUp key={rev.date} delay={(i % 4) * 0.08}>
              <figure
                data-testid={`review-card-${i}`}
                className="flex h-full flex-col rounded-3xl border border-federasol-terra/10 bg-federasol-cream p-6 shadow-[0_14px_40px_-20px_rgba(64,49,47,0.18)] transition-all duration-500 ease-soft hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(166,93,71,0.3)]"
              >
                <div className="flex items-center justify-between">
                  <div
                    data-testid={`review-stars-${i}`}
                    className="flex gap-0.5"
                    role="img"
                    aria-label="5 / 5"
                  >
                    {[0, 1, 2, 3, 4].map((s) => (
                      <Star key={s} className="h-4 w-4 fill-federasol-rose text-federasol-rose" />
                    ))}
                  </div>
                  <GoogleG />
                </div>
                <blockquote className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-federasol-cocoa">
                  “{rev.quote}”
                </blockquote>
                <figcaption className="mt-5 border-t border-federasol-terra/10 pt-4">
                  <p className="flex items-center gap-2 text-sm font-semibold text-federasol-cocoa">
                    <span className="text-federasol-terra"><GoogleG /></span>
                    {R.guestName}
                  </p>
                  <p className="mt-0.5 text-xs text-federasol-muted">{fmt(rev.date)}</p>
                </figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.2} className="mt-10 text-center">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-button"
            className="btn-outline"
          >
            {R.seeAll}
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
